export const zs_Global = (set) => ({
  breakpointStr: "",
  setBreakpointStr: (v) => set(() => ({ breakpointStr: v })),
  breakpointInt: 0,
  setBreakpointInt: (v) => set(() => ({ breakpointInt: v })),
});
